import React, { ReactNode } from 'react';

import { ErrorCodes } from '@src/types/errors';
import { bemCssModules, getTestId } from '@utils';
import { useDidMountEffect, useTimeout, useLocation } from '@utils/hooks';

import CloseButton from './CloseButton';

import style from './Notification.scss';

const cn = bemCssModules(style, 'Notification');
const ti = getTestId('Notification');

const HIDE_TIMEOUT = 5000;

export type TNotification = {
  title?: string;
  code?: ErrorCodes;
  onClose?: () => void;
  message: ReactNode;
  error?: boolean;
};

const Notification: CustomFC<TNotification> = props => {
  const { className, title, message, code, onClose, error } = props;

  const { pathname } = useLocation();

  useDidMountEffect(() => {
    if (error) onClose?.();
  }, [pathname, error]);

  useTimeout(() => !error && onClose?.(), HIDE_TIMEOUT);

  return (
    <div className={cn(null, [className, 'small'])} data-testid={ti()}>
      {title && <b className={cn('title', { error })}>{title} </b>}
      {message}
      {code && error && <div className={cn('code')}>{code}</div>}
      <CloseButton onClick={onClose} />
    </div>
  );
};

export default Notification;
